import { render, staticRenderFns } from "./StudentSubmissions.vue?vue&type=template&id=b7a625c8&scoped=true"
import script from "./StudentSubmissions.vue?vue&type=script&lang=js"
export * from "./StudentSubmissions.vue?vue&type=script&lang=js"
import style0 from "./StudentSubmissions.vue?vue&type=style&index=0&id=b7a625c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a625c8",
  null
  
)

export default component.exports